module.exports = __webpack_public_path__ + "assets/img/burst_ark.af063e89.png";